import React from 'react';
import './TIktok.css';

const Tiktok = () => {
  return (
    <div className="tiktok-container">
      <div className="grid-container">

        <div className="grid-sub-container">
          <div className="container-second">
            <p className="p-front">Social Media Management</p>
            <p className="p-back">
              We build systems and strategies that make your brand stand out while saving you time, ensuring consistency, stronger connections, and loyal customers.
            </p>
          </div>
          <div className="container-second">
            <p className="p-front">Content Creation</p>
            <p className="p-back">
              Our creative team crafts impactful content that builds brand loyalty and drives engagement across every platform, from IG and LinkedIn to YouTube, Facebook, and Facebook Communities.
            </p>
          </div>
          <div className="container-second">
            <p className="p-front">Virtual Challenges</p>
            <p className="p-back">
              Leverage our expertise in orchestrating interactive virtual 3 or
              5-day challenges that engage your community, boost participation
              while converting warm leads
            </p>
          </div>
          <div className="container-second">
            <p className="p-front">Consultation as DIY</p>
            <p className="p-back">
              Empower your team with our DIY consultation services, providing
              expert guidance to help you navigate the complex landscape of
              Online Marketing
            </p>
          </div>
          <div className="container-second">
            <p className="p-front">SEO Optimization</p>
            <p className="p-back">
              Elevate your Google rankings with our targeted SEO strategies that
              increase organic traffic, improve search visibility, and drive
              meaningful engagement.
            </p>
          </div>

          <div className="container-second">
            <p className="p-front">Web Development</p>
            <p className="p-back">
              Our skilled developers craft seamless, responsive websites that
              ensure your digital presence is both visually stunning and
              functionally robust.
            </p>
          </div>
        
        <div className="container-second">
            <p className="p-front">Events & PR in Dubai</p>
            <p className="p-back">
            From intimate gatherings to large-scale events, we help you host seamlessly and gain media coverage in Dubai through PR and news publishing.
            </p>
          </div>
        <div className="container-second">
            <p className="p-front">Email Marketing</p>
            <p className="p-back">
            We craft email sequences, weekly newsletters, and challenge campaigns that convert. From abandoned cart emails to detailed, psychology-driven copy, we ensure every message connects with your community and drives results.
            </p>
          </div>
          </div>

      </div>
    </div>
  );
};

export default Tiktok;
